import { render, staticRenderFns } from "./AlignGroup.vue?vue&type=template&id=db3a57c6&scoped=true&"
import script from "./AlignGroup.vue?vue&type=script&lang=js&"
export * from "./AlignGroup.vue?vue&type=script&lang=js&"
import style0 from "./AlignGroup.vue?vue&type=style&index=0&id=db3a57c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3a57c6",
  null
  
)

export default component.exports